import { useInfo } from '@/store';

/**
 * Image filename need to follow the rule {name}_{device}
 * Example: 
 * @Input: icon_pc
 * @Output: CDN path of icon_mobile, icon_tablet, icon_pc
 * @param pc accept image name with pc
 * @returns mobile and tablet image path.
 */
const exception = ['workshop_pc_sticker1', 'workshop_pc_sticker2', 'workshop_pc_sticker3']
function getRwdImg(pc: string, withTablet = true) {
  const { getImg } = useInfo();
  if (exception.includes(pc)) {
    return {
      backgroundUrl: {
        pc: '',
        mobile: `url(${getImg(pc.replace('pc', 'mobile'))})`,
        tablet: ``,
      },
      imgSrc: {
        pc: '',
        mobile: getImg(pc.replace('pc', 'mobile')),
        tablet: '',
      }
    }
  }
  else return {
    backgroundUrl: {
      pc: `url(${getImg(pc)})`,
      mobile: `url(${getImg(pc.replace('pc', 'mobile'))})`,
      tablet: withTablet ? `url(${getImg(pc.replace('pc', 'tablet'))})` : '',
    },
    imgSrc: {
      pc: getImg(pc),
      mobile: getImg(pc.replace('pc', 'mobile')),
      tablet: withTablet ? getImg(pc.replace('pc', 'tablet')) : '',
    }
  }
}

export default getRwdImg
